import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  useDisclosure,
} from '@chakra-ui/react'
import { FC } from 'react'
import { MdAdd } from 'react-icons/md'
import { PageEnum } from '..'
import UploadPage from './uploadPage'

interface IProps {
  setPage: (value: React.SetStateAction<PageEnum>) => void
}

const AddModelHeader: FC<IProps> = ({ setPage }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box>
      <Button variant="brand" onClick={onOpen}>
        <MdAdd></MdAdd>
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Upload Model</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box as="article" m="15px 5px">
              <UploadPage setPage={setPage} />
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button
              variant="outline"
              colorScheme="brand"
              mr={3}
              onClick={onClose}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}

export default AddModelHeader
